import NavBar from './components/Navbar';
import './App.css';
import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './Home';
import UserProfileSelection from './UserProfileSelection';
import { PATH } from './constants';
import RentalTextileLaundry from './RentalTextileLaundry';
import Footer from './components/Footer';
import OAuth2Callback from './Oauth2Callback';
import UserFRClothing from './UserFRClothing';
import Loading from './components/Loading';
import ProtectedRoute from './components/ProtectedRoute';
import NotFound from './NotFound';
import MainLayout from './components/MainLayout';
import MinimalLayout from './components/MinimalLayout';

function App() {
  const location = useLocation();

  // Logic to check if it's the 404 page (NotFound) or the homepage '/'
  const is404Page = location.pathname === '/404' || location.pathname === '*';
  const isHomePage = location.pathname === '/';

  return (
    <div className="App">


      <Routes>
        <Route 
          path='/' 
          element={location.search.includes('code') ? <OAuth2Callback /> : <MinimalLayout> <Loading /> </MinimalLayout>} 
        />
        <Route path='/home' element={
          <MainLayout>
          <ProtectedRoute><Home/></ProtectedRoute>
          </MainLayout>
        } />     
        <Route path={PATH.userProfileSelectionPath} element={
          <MainLayout>
          <ProtectedRoute><UserProfileSelection/></ProtectedRoute>
          </MainLayout>
          } />
        <Route path={PATH.rentalTextileLaundryPath} element={
          <MainLayout>
          <ProtectedRoute><RentalTextileLaundry/></ProtectedRoute>
          </MainLayout>
          } />
        <Route path={PATH.frClothingPath} element={
           <MainLayout>
          <ProtectedRoute>
          <UserFRClothing/>
          </ProtectedRoute>
          </MainLayout>
        } />
               
        {/* Catch-all route for 404 NotFound */}
        <Route path='*' element={<NotFound />} />
      </Routes>

    </div>
  );
}

export default App;
